module.exports = __webpack_public_path__ + "static/media/DecorationService.38eafa32.jpg";